import { fromIumSourceToPath } from "../../../transformation/source_zip.js";
/**
 * Migrate index from v1 to v2.
 * Add `paths` property in `index`, associate uuid to zip path, and `<uuid>_legacy` to legacy zip path.
 * @param index - the index to migrate
 * @returns the index migrated
 */
export function migrateV1ToV2(index) {
    const paths = {};
    for (const source of index.sources) {
        const [, zipPath, legacyZipPath] = fromIumSourceToPath(source);
        paths[source.uuid] = zipPath;
        paths[`${source.uuid}_legacy`] = legacyZipPath;
    }
    return {
        ...index,
        version: 2,
        paths,
    };
}
//# sourceMappingURL=v01_to_v02.js.map